import styled from 'styled-components';

export const InputError = styled.p`
  color: ${({ theme }) => theme.colors.red};
  margin: 4px;
  font-size: 0.8rem;
`;
